/* Package JSON Import will be here */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Security from '../../scenes/security/security.Container';
import TimeCard from '../../scenes/timeCard/timeCard.Container';
import SecurityPage from '../../scenes/security/securityPage/securityPage.Container';
import Projects from '../../scenes/projects/projects.Container';
import Employee from '../../scenes/employee/employee.Container';
import Report from '../../scenes/report/report.Container';
import ReportPage from '../../scenes/report/reportPage/reportPage.Container';
import Devices from '../../scenes/devices/devices.Container';
import LoginLanding from '../../scenes/loginLanding/loginLanding.Container';
import Login from '../../scenes/login/login.Container';
import AdminLogin from '../../scenes/adminLogin/adminLogin.Container';
import ForeCast from '../../scenes/forecast/forcast.Container';
import { Constants } from '../appConstants';
import AuthenticateRoute from '../../scenes/sharedComponent/authenticateRoute';
import DivisionPage from '../../scenes/divisions/divisions.container';
import PayRollNoteOptionPage from '../../scenes/payRollNoteOptions/payRollNoteOptions.container';
import EquipmentListPage from "../../scenes/equipmentList/equipmentList.container";
import NotFound from '../../scenes/sharedComponent/notFound/index';
import StatusCodeListPage from '../../scenes/statusCodeList/statusCodeList.container';
import TMVoucherPage from '../../scenes/tmVoucher/tmVoucher.Container';
import MaterialListPage from '../../scenes/materialList/materialList.container';
import SupervisorOverrideReasonPage from '../../scenes/supervisorOverrideReason/supervisorOverrideReason.container';
/* Package JSON Import will be here */

/* Project Import will be here */

/* -------------------- Common Component will be here --------------------*/
/* Account Component will be here */

/* Project Import will be here */

//todo: Make route path url's as path constants to resuse path's constants on route navigations
const Routers = (props) => {
    console.log("Routerprops", props);
    return (
        <Switch>
            <Route exact path="/" render={(props) => <Login {...props} />} />
            <Route component={Login} path="/Login" />
            <Route component={AdminLogin} path="/Admin" />
            <Route component={LoginLanding} path="/LoginLanding" />
            {/* <AuthenticateRoute authorizedClaim={Constants.SECURITY_MENU} component={Security} path="/Security" /> */}
            {/* <Route component={Security} path="/Security" /> */}
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.SECURITY_PAGE} component={Security} path="/Security" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.SECURITY_PAGE} component={SecurityPage} path="/SecurityPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.PROJECT_PAGE} component={Projects} path="/Projects" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.EMPLOYEE_PAGE} component={Employee} path="/Employee" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.DEVICE_PAGE} component={Devices} path="/Devices" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.TIMECARD_PAGE} component={TimeCard} path="/TimeCard" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.REPORT_PAGE} component={Report} path="/Report" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.REPORT_PAGE} component={ReportPage} path="/ReportPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.DIVISION_PAGE} component={DivisionPage} path="/DivisionPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.FORECAST_PAGE} component={ForeCast} path="/ForeCast" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.PAYROLLNOTEOPTION_PAGE} component={PayRollNoteOptionPage} path="/PayRollNoteOptionPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.STATUSCODELIST_PAGE} component={StatusCodeListPage} path="/StatusCodeListPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.EQUIPMENTLIST_PAGE} component={EquipmentListPage} path="/EquipmentListPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.MATERIALLIST_PAGE} component={MaterialListPage} path="/MaterialListPage" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.TMVOUCHER_PAGE} component={TMVoucherPage} path="/TMVoucher" />
            <AuthenticateRoute authorizedClaim={Constants.PAGE_CLAIMS.SUPERVISOROVERRIDEREASONLIST_PAGE} component={SupervisorOverrideReasonPage} path="/SupervisorOverrideReason" />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default Routers;

Routers.displayName = 'Router';